export enum ScreenView {
    tableMobile = 'tableMobile',
    tableDesktop = 'tableDesktop',
    accordionDeskTop = 'accordionDesktop',
    accordionMobile = 'accordionMobile',
    desktop = 'desktop',
    mobile = 'mobile',
}
export enum UserStatus {
    active = 'active',
    inactive = 'inactive',
}

export enum KeyEvent {
    tab = 'Tab',
    enter = 'Enter',
    shift = 'Shift'
}

export enum LibIcons {
    loaderWhite = 'assets/Loader2.gif',
    widgetLoader = 'assets/widgetloader.gif',
    loaderWithOutText = 'assets/loader-without-text.gif'
}

export enum NullCheck{
    nullValue= '—'
}
